import moment, { Moment } from 'moment';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import {
  getWeekPreset,
  getWeekStartDate,
} from 'components/organisms/timesheets/common/utils';
import { WeekPreset } from 'components/organisms/timesheets/types';

interface Props {
  validWeekPresets: WeekPreset[];
  allowedWeekPresetsInUrl: WeekPreset[];
  defaultStartDate: Moment;
  url: string;
}
export const useTimesheetUrlState = ({
  validWeekPresets,
  allowedWeekPresetsInUrl,
  defaultStartDate,
  url,
}: Props): {
  startDate: Moment;
  setStartDate: (value: Moment) => void;
  weekInUrl: string;
} => {
  const { week: weekInUrl, userId: userIdInUrl } =
    useParams<{ week: string; userId: string }>();

  const isWeekInUrlValid =
    moment(weekInUrl, 'YYYY-MM-DD').isValid() ||
    validWeekPresets.includes(weekInUrl as WeekPreset);

  const [selectedDay, setSelectedDay] = useState<Moment>(
    isWeekInUrlValid ? getWeekStartDate(weekInUrl) : defaultStartDate,
  );
  const { replace } = useHistory();

  useEffect(() => {
    if (
      !getWeekStartDate(weekInUrl).isSame(selectedDay, 'day') ||
      (validWeekPresets.includes(weekInUrl as WeekPreset) &&
        !allowedWeekPresetsInUrl.includes(weekInUrl as WeekPreset))
    ) {
      let _url = url.replace(
        ':week',
        getWeekPreset(selectedDay, allowedWeekPresetsInUrl),
      );

      if (userIdInUrl) {
        _url = _url.replace(':userId', userIdInUrl);
      }
      replace(_url);
    }
  }, [
    userIdInUrl,
    weekInUrl,
    replace,
    selectedDay,
    allowedWeekPresetsInUrl,
    validWeekPresets,
    url,
  ]);

  return {
    startDate: selectedDay,
    setStartDate: setSelectedDay,
    weekInUrl,
  };
};
